import moment from 'moment';
import { useEffect, useState } from 'react'
import LavorisService from '../../services/LavorisService';
import { RootState } from '../../store/combineReducer';
import { useSelector } from 'react-redux';
import { useModal } from '../../hooks';
import { styled } from '@mui/material/styles';
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import { useAlert } from '../../hooks/useAlert';
import { Badge, BadgeProps } from '@mui/material';
import { TableActions } from '../../components/others/TableActions';
import { appointmentStatus } from '../../utils/appointmentStatus';
import { filterMoldeExamPractice } from '../../utils/filterMoldeExamPractice';
import { DetailTurnWithDateParticular } from '../others/detailsTurnParticular';
import RequestTurn from '../others/requestTurn';
import { useSearchParams } from 'react-router-dom';
import EliminarModal from "../../components/others/EliminarModal";
import { TParticularPatient } from './Turnos.type';
import EditTurn from '../others/editTurn';
import InfoOffcanvas from '../../components/others/InfoOffCanvas/InfoOffCanvas';
import InfiniteTable from '../../components/others/InfiniteTableComponent/IntiniteTableComponent';
import "./particular_client.scss";

const VIEW_APPOINTMENTS_MODAL = "viewAppointmentsModal";
const DELETE_PARTICULAR_APPOINTMENT_MODAL = "deleteParticularAppointmentModal";
const EDIT_PARTICULAR_APPOINTMENT_MODAL = "editParticularAppointmentModal";

const ParticularClientTurns = () => {
    const [hasMore, setHasMore] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const LavorisInstance = LavorisService.getInstance();
    const userId = useSelector((state: RootState) => state.user.userId);
    const [chosenAppointment, setChosenAppointment] =
        useState<TParticularPatient>();
    const { closeModal, openModal, isActive } = useModal();
    const { showAlert } = useAlert();
    const [items, setItems] = useState({
        itemsPerPage: 20,
        page: 1,
    });
    // useStates

    const [data, setData] = useState<any[]>([]);
    const [loader, setLoader] = useState(false);
    const controller = new AbortController();
    const signal = controller.signal;

    const getAllAppointmentsCall = async () => {
        setLoader(true);
        try {
            const app = await LavorisInstance.TurnServices.getParticularClientsApp(
                items.page,
                items.itemsPerPage,
                "",
                "",
                signal
            )

            if (app.length === 0) {
                //showAlert("No se encontraron registros");
                setHasMore(false);
                return;
            }

            // Obtén los IDs de las citas actuales en el estado
            const existingIds = new Set(data?.map(item => item.id));

            // Filtra las nuevas citas para agregar solo las que no están en el estado actual
            const uniqueAppointments = app?.filter(appointment => !existingIds.has(appointment.id));

            // Agrega nuevos app al estado existente
            setData(prevData => {
                return [...prevData, ...uniqueAppointments];
            });
            //Incrementa la página
            setItems(prev => ({ ...prev, page: prev.page + 1 }));
        } catch (e) {
            console.log(e);
            setHasMore(false);
        } finally {
            setLoader(false);
        }
    }

    const getAllAppointmentsRefresh = async () => {
        setLoader(true);
        try {
            const app = await LavorisInstance.TurnServices.getParticularClientsApp(
                1,
                20,
                "",
                "",
                signal
            )

            if (app.length === 0) {
                //showAlert("No se encontraron registros");
                setHasMore(false);
                return;
            }
            setData([]);
            setData(app);
            setItems(prev => ({ ...prev, page: prev.page + 1 }));
        } catch (e) {
            console.log(e);
            setHasMore(false);
        }
        finally {
            setLoader(false);
        }
    }

    useEffect(() => {
        getAllAppointmentsCall();
    }, [])

    useEffect(() => {
        return () => {
            controller.abort()
        };
    }, [])


    const [searchParams, setSearchParams] = useSearchParams("");

    const HandleDeletion = async () => {
        setIsLoading(true);
        try {
            let turnID: any = searchParams.get("rowId");
            await LavorisInstance.TurnServices.DeleteTurn(turnID);
            closeModal(DELETE_PARTICULAR_APPOINTMENT_MODAL)
            getAllAppointmentsRefresh()
        } catch (e) {
            console.log(e);
            return alert('No se pudo eliminar el turno, intente nuevamente mas tarde');
        } finally {
            setIsLoading(false);
        }
    };

    const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
        <Tooltip {...props} classes={{ popper: className }} />
    ))(({ theme }) => ({
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: '#f5f5f9',
            color: 'rgba(0, 0, 0, 0.87)',
            maxWidth: 220,
            fontSize: theme.typography.pxToRem(12),
            border: '1px solid #dadde9',
        },
    }));

    const StyledBadge = styled(Badge)<BadgeProps>(({ theme }) => ({
        '& .MuiBadge-badge': {
            right: -3,
            top: 13,
            border: `2px solid ${theme.palette.background.paper}`,
            padding: '0 4px',
            margin: '0  4px'
        },
    }));

    const returnRetiro = (rowData: any) => {
        if (!rowData?.actions || rowData?.actions?.length === 0) return '---';

        const retirado = rowData?.actions.filter((action: any) => action.action === 'RETIRADO');
        if (retirado.length === 0) return '---';
        // Asegúrate de convertir la fecha de UTC a la zona horaria correcta
        return moment(retirado[0].date).format('DD/MM/YY HH:mm');
    };

    return (
        <>
            <div className="main-container particular-client-turns-container">
                <div className="atendoo-card">
                    <div className="custom-header">
                        <div className="header-top">
                            <h6 className="subtitle">Solicitudes de Turnos</h6>
                            <InfoOffcanvas title="INFORMACIÓN DE TABLA">
                                <ul className="text-md p-auto m-auto">
                                    <li>- A medida que se va haciendo scroll para abajo, la tabla va buscando más resultados.</li>
                                </ul>
                            </InfoOffcanvas>
                        </div>

                        <div className="header-controls">
                            <div className='d-flex gap-2'>

                                {/* Results Count */}
                                <div className="results-count">
                                    <span className="count-number">{data.length}</span>
                                    <span className="count-label">turnos</span>
                                </div>

                                {/* Refresh Button */}
                                <button
                                    className="refresh-btn"
                                    onClick={getAllAppointmentsRefresh}
                                    title="Actualizar tabla"
                                    disabled={loader}
                                >
                                    {loader ? (
                                        <div className="loading-spinner">
                                            <div className="spinner"></div>
                                        </div>
                                    ) : (
                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                            <path
                                                d="M13.65 2.35C12.2 0.9 10.21 0 8 0 3.58 0 0 3.58 0 8s3.58 8 8 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L9 5h7V-2l-2.35 2.35z"
                                                fill="currentColor"
                                            />
                                        </svg>
                                    )}
                                    <span className="btn-text">Actualizar</span>
                                </button>
                            </div>

                            {/* Refresh Button */}
                            <button
                                className="add-btn"
                                onClick={() => {
                                    openModal("modalRequestTurn", userId)
                                }}
                                title="Nuevo turno"
                                disabled={loader}
                            >
                                {loader ? (
                                    <div className="loading-spinner">
                                        <div className="spinner"></div>
                                    </div>
                                ) : (
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M8 3.333v9.334M3.333 8h9.334" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                                )}
                                <span className="btn-text">Nuevo Turno</span>
                            </button>

                        </div>
                    </div>
                </div>

                <InfiniteTable
                    data={data}
                    columns={[
                        // {
                        //     key: 'patient_name',
                        //     title: 'Apellido y Nombre',
                        //     className: 'col-name',
                        //     expandable: false,
                        //     render: (value: any, row: any) => (
                        //         row?.patient?.name?.toUpperCase() || "---"
                        //     )
                        // },
                        {
                            key: 'createdDate',
                            title: 'Fecha de solicitud',
                            className: 'col-request-date',
                            render: (value: any, row: any) => (
                                moment(row.createdDate).format('DD/MM/YY HH:mm') || "---"
                            )
                        },
                        {
                            key: 'turnDate',
                            title: 'Fecha y hora del turno',
                            className: 'col-turn-date',
                            render: (value: any, row: any) => (
                                row.date && row.startTime ? `${row.date} - ${row.startTime}` : "---"
                            )
                        },
                        {
                            key: 'admissionTime',
                            title: 'Fecha y hora de admisión',
                            className: 'col-admission-particular-date',
                            render: (value: any, row: any) => (
                                row.admissionTime ? row.admissionTime : "---"
                            )
                        },
                        {
                            key: 'retiro',
                            title: 'Fecha y hora de retiro',
                            className: 'col-retiro-date',
                            render: (value: any, row: any) => (
                                returnRetiro(row)
                            )
                        },
                        {
                            key: 'status',
                            title: 'Estado',
                            className: 'col-status',
                            render: (value: any, row: any) => (
                                appointmentStatus(row)
                            )
                        },
                        {
                            key: 'description',
                            title: 'Descripción',
                            className: 'col-description',
                            render: (value: any, row: any) => (
                                filterMoldeExamPractice(row) || "---"
                            )
                        },
                        {
                            key: 'actions',
                            title: 'Acciones',
                            className: 'col-actions',
                            render: (value: any, row: any) => (
                                <div className="flex gap-2 justify-center">
                                    <TableActions
                                        type="View"
                                        onClick={() => openModal(VIEW_APPOINTMENTS_MODAL, row.id)}
                                    />
                                    {row.status === 'Solicitado' && (
                                        <>
                                            <TableActions
                                                type="Delete"
                                                onClick={() => {
                                                    setItems({
                                                        page: 1,
                                                        itemsPerPage: 20
                                                    });
                                                    setChosenAppointment(row.patient);
                                                    openModal(DELETE_PARTICULAR_APPOINTMENT_MODAL, row.id);
                                                }}
                                            />
                                            <TableActions
                                                type="Edit"
                                                onClick={() => {
                                                    setItems({
                                                        page: 1,
                                                        itemsPerPage: 20
                                                    });
                                                    setChosenAppointment(row.patient);
                                                    openModal(EDIT_PARTICULAR_APPOINTMENT_MODAL, row.id);
                                                }}
                                            />
                                        </>
                                    )}
                                </div>
                            )
                        }
                    ]}
                    loading={loader}
                    hasMore={hasMore}
                    onLoadMore={getAllAppointmentsCall}
                    height={300}
                />
            </div>

            {
                isActive(VIEW_APPOINTMENTS_MODAL) && (
                    <DetailTurnWithDateParticular
                        show
                        modalTitle={"Detalle de turno"}
                        urlTittle={VIEW_APPOINTMENTS_MODAL}
                        closeModal={() => closeModal(VIEW_APPOINTMENTS_MODAL)}
                    />
                )
            }
            {
                isActive("modalRequestTurn") && (
                    <RequestTurn
                        toggleModal
                        onClose={() => closeModal('modalRequestTurn')}
                        urlTittle={"modalRequestTurn"}
                        refreshFunction={() => {
                            closeModal('modalRequestTurn');
                            showAlert('El turno se solicitó con exito. Lavoris se contactará para comunicarle el día y el horario del turno')
                            getAllAppointmentsRefresh()
                        }}
                        patientType="PARTICULAR_CLIENT"
                    />
                )}

            {
                isActive(DELETE_PARTICULAR_APPOINTMENT_MODAL) && (
                    <EliminarModal
                        toggleModal
                        name={chosenAppointment?.name || ""}
                        handleDeletion={HandleDeletion}
                        urlTittle={DELETE_PARTICULAR_APPOINTMENT_MODAL}
                        isLoading={isLoading}
                    />
                )
            }

            {isActive(EDIT_PARTICULAR_APPOINTMENT_MODAL) && (
                <EditTurn
                    toggleModal
                    urlTittle={EDIT_PARTICULAR_APPOINTMENT_MODAL}
                    patient={chosenAppointment}
                    refreshFunction={() => {
                        closeModal(EDIT_PARTICULAR_APPOINTMENT_MODAL);
                        getAllAppointmentsRefresh()
                    }}
                />
            )}

        </>
    )
}

export default ParticularClientTurns